import { useCallback } from 'react';
import { useSnackbarContext } from '@monorepo/nova-ui';
import { SnackbarOrigin } from '@mui/material/Snackbar';

export const useErrorSnackbar = () => {
  const { showSnackbar } = useSnackbarContext();

  const showError = useCallback(
    (
      error: Error | string,
      customMessage?: string,
      anchorOrigin?: SnackbarOrigin,
    ) => {
      const message =
        customMessage || (typeof error === 'string' ? error : error.message);

      showSnackbar({
        message: message,
        severity: 'error',
        anchorOrigin,
      });
    },
    [showSnackbar],
  );

  const showSuccess = useCallback(
    (message: string, anchorOrigin?: SnackbarOrigin) => {
      showSnackbar({
        message,
        severity: 'success',
        anchorOrigin,
      });
    },
    [showSnackbar],
  );

  const showWarning = useCallback(
    (message: string, anchorOrigin?: SnackbarOrigin) => {
      showSnackbar({
        message,
        severity: 'warning',
        anchorOrigin,
      });
    },
    [showSnackbar],
  );

  const showInfo = useCallback(
    (message: string, anchorOrigin?: SnackbarOrigin) => {
      showSnackbar({
        message,
        severity: 'info',
        anchorOrigin,
      });
    },
    [showSnackbar],
  );

  return {
    showError,
    showSuccess,
    showWarning,
    showInfo,
  };
};
